import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'states/store';

export const select = (state: RootState) => state.account;

export const selectStatus = createSelector(select, (state) => state.status);
